import React from "react";
import { Container, Flex, Title, Text, List } from "@mantine/core";
import {
  CustomContentGrid,
  CustomSplitTitle,
  CustomBrandCarousel,
} from "@components/custom";
import { CustomFooter } from "@/src/components/footer/footer";
import MobileJumbotronImage from "@images/backgrounds/mobile-jumbotron-bg.png";
import MobileJumbotronContentImageOne from "@images/content/mobile-jumbotron-one.png";
import MobileJumbotronContentImageTwo from "@images/content/mobile-jumbotron-two.png";
import MobileBeingAFounder from "@images/content/mobile-being-a-founder.png";

// Brand Images
import Phizz from "@images/content/carousel/1-phizz.png";
import OddlyGood from "@images/content/carousel/2-oddly-good.png";
import Yumello from "@images/content/carousel/3-yumello.png";
import LittleDish from "@images/content/carousel/4-little-dish.png";
import NeatSweets from "@images/content/carousel/5-neat-sweets.png";
import CocoCubes from "@images/content/carousel/6-coco-cubes.png";
import Freja from "@images/content/carousel/7-freja.png";
import BetterYou from "@images/content/carousel/8-better-you.png";
import Dalstons from "@images/content/carousel/9-dalstons.png";

// Testimonial Images
import Duncan from "@images/content/testimonials/ACBRANDS-Duncan.jpg";
import Glen from "@images/content/testimonials/ACBRANDS-Glen.jpg";
import John from "@images/content/testimonials/ACBRANDS-John.jpg";
import Mark from "@images/content/testimonials/ACBRANDS-Mark.jpg";
import Omar from "@images/content/testimonials/ACBRANDS-Omar.jpg";
import Trudy from "@images/content/testimonials/ACBRANDS-Trudy.jpg";

import { motion } from "framer-motion";
import MobileChallengersImage from "@images/backgrounds/mobile-challengers.png";
import DesktopChallengersImage from "@images/backgrounds/desktop-challengers.png";
import { CustomNumberList } from "@components/custom";
import DesktopJumbotronImage from "@images/backgrounds/desktop-jumbotron.png";
import DesktopJumbotronContentImageOne from "@images/content/mobile-jumbotron-one-desktop.png";
import DesktopJumbotronContentImageTwo from "@images/content/mobile-jumbotron-two-desktop.png";
import DesktopBeingAFounder from "@images/content/being-a-founder-desktop.png";
import { useResponsiveImage } from "@hooks/useResponsiveImage";

// Styles
import styles from "@scss/custom-components/custom-jumbotron.module.scss";
import stylesContainer from "@scss/custom-components/custom-container.module.scss";
import { CustomTestimonialsCarousel } from "@/src/components/custom/testimonials/custom-testimonials-carousel";

export const HomeIndex: React.FC = () => {
  const brandImages = [
    Phizz,
    OddlyGood,
    Yumello,
    LittleDish,
    NeatSweets,
    CocoCubes,
    Freja,
    BetterYou,
    Dalstons,
    Phizz,
    OddlyGood,
    Yumello,
    LittleDish,
    NeatSweets,
    CocoCubes,
    Freja,
    BetterYou,
    Dalstons,
  ];
  const testimonialImages = [Duncan, Glen, John, Mark, Omar, Trudy];

  // Use responsive image hook for jumbotron background
  const jumbotronBgImage = useResponsiveImage(
    MobileJumbotronImage,
    DesktopJumbotronImage,
  );
  const jumbotronImageOne = useResponsiveImage(
    MobileJumbotronContentImageOne,
    DesktopJumbotronContentImageOne,
  );
  const jumbotronImageTwo = useResponsiveImage(
    MobileJumbotronContentImageTwo,
    DesktopJumbotronContentImageTwo,
  );

  const beingAFounderImage = useResponsiveImage(
    MobileBeingAFounder,
    DesktopBeingAFounder,
  );

  const items = [
    {
      title: "Win New Business.",
      description:
        "We define your brand's key wholesalers, win them, target their highest-value customers, and scale revenue through those channels—leaving you with the contacts, data, and CRM to own it long-term and that all-important sales revenue roadmap.",
    },
    {
      title: "Keep Growth on Track.",
      description:
        "Winning the listing means nothing if it doesn’t move.<br/><br/>We stay hands-on—driving sell-through, managing the relationship, and turning accounts into consistent revenue - Full end-to-end account management, with established relationships to move the needle fast.",
    },
    {
      title: "Strategically grow, stop the guesswork.",
      description:
        "We identify the channels that drive real revenue, prioritise them properly, and build a roadmap that takes you from early-stage to emerging challenger at pace — saving you from wasting time or budget.",
    },
  ];

  return (
    <>
      <CustomContentGrid.Jumbotron
        mobileBgImage={jumbotronBgImage}
        desktopBgImage={jumbotronBgImage}
      >
        <Container p={0} className={styles.jumbotronContainer}>
          <Flex
            justify="space-between"
            align="center"
            mb="xl"
            style={{ position: "relative" }}
          >
            <motion.img
              src={jumbotronImageOne}
              alt=""
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{
                duration: 1,
                delay: 1.4,
                scale: { type: "spring", visualDuration: 1, bounce: 0.5 },
              }}
              className={styles.jumbotronImageOne}
            />
            <Title
              order={1}
              tt="uppercase"
              style={{
                position: "absolute",
                width: "1px",
                height: "1px",
                padding: 0,
                margin: "-1px",
                overflow: "hidden",
                clip: "rect(0, 0, 0, 0)",
                whiteSpace: "nowrap",
                border: 0,
              }}
            >
              No‑fluff growth partner for UK food & drink challenger brands
            </Title>
            <CustomSplitTitle
              order={1}
              uppercase
              partA="No‑fluff growth partner for <br/>UK food & drink"
              partB="challenger brands"
              partAStyle={{ color: "#FFF" }}
              partBStyle={{ color: "#A4F9AD" }}
              aria-hidden="true"
              textAlign="center"
              useMaskAnimation={true}
              animationDelay={0.2}
              animationDuration={0.8}
              removeBreaksOnDesktop={true}
              mainTitle={true}
            />
            <motion.img
              src={jumbotronImageTwo}
              alt=""
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{
                duration: 1,
                delay: 1.4,
                scale: { type: "spring", visualDuration: 1, bounce: 0.5 },
              }}
              className={styles.jumbotronImageTwo}
            />
          </Flex>
        </Container>
      </CustomContentGrid.Jumbotron>

      <Container m={0} className={stylesContainer.customContainer}>
        <CustomContentGrid.Main>
          <Flex justify="space-between" align="center" mb="xl">
            <Title
              order={2}
              style={{
                position: "absolute",
                width: "1px",
                height: "1px",
                padding: 0,
                margin: "-1px",
                overflow: "hidden",
                clip: "rect(0, 0, 0, 0)",
                whiteSpace: "nowrap",
                border: 0,
              }}
            >
              Meet our brand partners past and present
            </Title>
            <CustomSplitTitle
              order={2}
              partA="Meet our brand partners <br/>"
              partB="past and present"
              partAStyle={{ color: "#000" }}
              partBStyle={{ color: "#000" }}
              aria-hidden="true"
              alignCenter
              textAlign="center"
            />
          </Flex>
        </CustomContentGrid.Main>
      </Container>

      <CustomBrandCarousel
        images={brandImages}
        autoplay={true}
        autoplayDelay={2500}
      />

      <Container m={0} className={stylesContainer.customContainer}>
        <CustomContentGrid.Main>
          <Flex
            justify="space-between"
            align="center"
            mb="xl"
            className={stylesContainer.beingAFounderSection}
          >
            <Flex direction="column">
              <Title
                order={2}
                style={{
                  position: "absolute",
                  width: "1px",
                  height: "1px",
                  padding: 0,
                  margin: "-1px",
                  overflow: "hidden",
                  clip: "rect(0, 0, 0, 0)",
                  whiteSpace: "nowrap",
                  border: 0,
                }}
              >
                Being a founder is chaotic
              </Title>

              <Flex justify="space-between" align="center" mb="xl">
                <CustomSplitTitle
                  order={2}
                  partA="Being a founder <br/>is "
                  partB="chaotic"
                  partAStyle={{ color: "#000" }}
                  partBStyle={{ color: "#000" }}
                  aria-hidden="true"
                />
              </Flex>
              <Text size="xl" mt={0}>
                You are spinning plates, pitching buyers, and building a team
                all at once.
                <br />
                <br />
                You know you’re ready to scale, but hiring exceptional senior
                talent this early is risky and expensive.
              </Text>
              <Text size="xl" fw={700}>
                You don't need another generic consultant.
                <br />
                <br />
                You need someone who gets the gig.
              </Text>
            </Flex>
            <Flex>
              <motion.img
                src={beingAFounderImage}
                alt=""
                initial={{ opacity: 0, scale: 0 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{
                  duration: 1,
                  delay: 0.6,
                  scale: { type: "spring", visualDuration: 1, bounce: 0.5 },
                }}
                style={{
                  width: "100%",
                  marginTop: "15px",
                  marginBottom: "24px",
                }}
              />
            </Flex>
          </Flex>
        </CustomContentGrid.Main>
      </Container>

      <CustomContentGrid.Main
        mobileBgImage={MobileChallengersImage}
        desktopBgImage={DesktopChallengersImage}
      >
        <Container m={0} className={stylesContainer.customContainer}>
          <Flex justify="space-between" align="center" mb="xl">
            <Title
              order={2}
              style={{
                position: "absolute",
                width: "1px",
                height: "1px",
                padding: 0,
                margin: "-1px",
                overflow: "hidden",
                clip: "rect(0, 0, 0, 0)",
                whiteSpace: "nowrap",
                border: 0,
              }}
            >
              How we put challengers on the map
            </Title>
            <CustomSplitTitle
              order={2}
              partA="How we put <br/>"
              partB="challengers "
              partC="on <br/>the map"
              partAStyle={{ color: "#fff" }}
              partBStyle={{ color: "#A4F9AD" }}
              partCStyle={{ color: "#fff" }}
              aria-hidden="true"
              alignCenter
              textAlign="center"
            />
          </Flex>
          <Text size="xl" variant="white" ta="center" mt={0}>
            At ACBRANDS, we act as your commercial engine, delivering fast-paced
            <br className="desktop-only" /> results without the headcount
            headache.
          </Text>
          <CustomNumberList items={items} />
        </Container>
      </CustomContentGrid.Main>

      <Container m={0} className={stylesContainer.customContainer}>
        <CustomContentGrid.Main>
          <Flex
            justify="space-between"
            className={stylesContainer.tenYearsSection}
            mb="xl"
          >
            <Flex direction="column">
              <Title
                order={2}
                style={{
                  position: "absolute",
                  width: "1px",
                  height: "1px",
                  padding: 0,
                  margin: "-1px",
                  overflow: "hidden",
                  clip: "rect(0, 0, 0, 0)",
                  whiteSpace: "nowrap",
                  border: 0,
                }}
              >
                Why work with us
              </Title>

              <Flex justify="space-between" align="center" mb="xl">
                <CustomSplitTitle
                  order={2}
                  partA="Why work with "
                  partB="us"
                  partAStyle={{ color: "#000" }}
                  partBStyle={{ color: "#000" }}
                  aria-hidden="true"
                />
              </Flex>

              {/* <Text size="xl" mt={0}>
                We combine startup grit with corporate discipline.<br/> Here is what that looks like in numbers:
              </Text> */}

              <List
                type="unordered"
                size="xl"
                mb="13px"
                style={{ maxWidth: "100%", wordWrap: "break-word" }}
              >
                <List.Item>
                  <Text size="xl" component="span" fw={700}>
                    ACBRANDS is your commercial engine{" "}
                  </Text>
                  — landing accounts, driving revenue, and making growth
                  measurable.
                </List.Item>
                <List.Item>
                  <Text size="xl" component="span" fw={700}>
                    10+ years{" "}
                  </Text>
                  inside Vita Coco, KIND Snacks, and Mars—we’ve got the scars
                  and know what actually works in this space.
                </List.Item>
                <List.Item>
                  <Text size="xl" component="span" fw={700}>
                    No fluff. No theory. Just results{" "}
                  </Text>
                  - tailored to your business, not ours.
                </List.Item>
              </List>
            </Flex>
            <Flex>
              <motion.img
                src={beingAFounderImage}
                alt=""
                initial={{ opacity: 0, scale: 0 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{
                  duration: 1,
                  delay: 0.6,
                  scale: { type: "spring", visualDuration: 1, bounce: 0.5 },
                }}
                style={{
                  width: "100%",
                  marginTop: "15px",
                  marginBottom: "24px",
                }}
              />
            </Flex>
          </Flex>
        </CustomContentGrid.Main>
      </Container>

      <Container m={0} className={stylesContainer.customContainer}>
        <CustomContentGrid.Main bordered mb0>
          <Flex justify="space-between" align="center" mb={0}>
            <Title
              order={2}
              style={{
                position: "absolute",
                width: "1px",
                height: "1px",
                padding: 0,
                margin: "-1px",
                overflow: "hidden",
                clip: "rect(0, 0, 0, 0)",
                whiteSpace: "nowrap",
                border: 0,
              }}
            >
              I get the gig.
            </Title>

            <Flex justify="space-between" align="center" mb="xl">
              <CustomSplitTitle
                order={2}
                partA="I get the  "
                partB="gig."
                partAStyle={{ color: "#000" }}
                partBStyle={{ color: "#000" }}
                aria-hidden="true"
                alignCenter
                textAlign="center"
              />
            </Flex>

            <Text size="xl" mt={0} ta="center">
              I founded ACBRANDS because I’ve been there. With a background
              spanning both corporate FMCG and high-growth startups.
              <br />
              <br />
              <strong>I understand the pressure to deliver.</strong>
            </Text>

            <Text size="xl" mt={0} mb={0} ta="center">
              <strong>My goal is simple:</strong> To be the senior expertise you
              need to break through the noise, specifically tailored for the UK
              Food & Drink sector.
            </Text>
          </Flex>
        </CustomContentGrid.Main>
      </Container>

      <Container m={0} className={stylesContainer.customContainer}>
        <CustomContentGrid.Main>
          <Flex justify="space-between" align="center" mb="xl">
            <Title
              order={2}
              style={{
                position: "absolute",
                width: "1px",
                height: "1px",
                padding: 0,
                margin: "-1px",
                overflow: "hidden",
                clip: "rect(0, 0, 0, 0)",
                whiteSpace: "nowrap",
                border: 0,
              }}
            >
              Testimonials
            </Title>
            <CustomSplitTitle
              order={2}
              partA="Testimonials"
              partB=""
              partAStyle={{ color: "#000" }}
              partBStyle={{ color: "#000" }}
              aria-hidden="true"
              alignCenter
              textAlign="center"
            />
          </Flex>
        </CustomContentGrid.Main>
      </Container>

      <CustomTestimonialsCarousel
        images={testimonialImages}
        autoplay={true}
        autoplayDelay={2500}
      />

      <Container m={0} p={0} className={stylesContainer.footerContainer}>
        <CustomFooter />
      </Container>
    </>
  );
};
